import publicSentiment from '@/router/dataInsight/sentiment/publicSentiment';
import research from '@/router/research/research';
import customerOrder from '@/router/customerorder/customerOrder';
import dataInsight from "@/router/dataInsight/dataInsights";
import empowerment from "@/router/empowerment/empowerment";
import personalCenter from "@/router/personalcenter/personalCenter";

 const asyncRouters = [
	
	empowerment,
	// 个人中心
	personalCenter,
]
export default asyncRouters;
